import SheetComponent from "./index";

import {Trans} from "@lingui/react/macro"
import {t} from "@lingui/core/macro"
import {currencyFormat} from "../../components/permissions/functions";
import {DynamicIcon} from "lucide-react/dynamic";
import moment from "moment";
import {MobCard} from "../components/MobCard";
import ApiService from "../../services/ApiService";
import {
    translateMethod,
    translateMethodIcon,
    translatePlatform,
    translateSource, translateSourceIcon, translateType,
} from '../../views/app-views/paiements/functions';
import ReactCountryFlag from "react-country-flag";
import React, {Fragment} from "react";
import { API_BASE_URL, ASSET_BASE_URL, isMobileApp, MOBCOLORS, MOBILE_PREFIX_PATH } from '../../configs/AppConfig';
import {Descriptions, Image, notification, Popconfirm} from "antd";
import IntlMessage from "../../components/util-components/IntlMessage";
import {removeFieldType} from "../../views/editors/WebEditor/formPlugins";
import ModalLink, {requestLinkPayload} from "../../modals/ModalLink";
import ModalUser from "../../modals/ModalUser";
import ModalContact from "../../modals/ModalContact";
import ModalCerfa from "../../modals/ModalCerfa";
import ModalEditCerfa from "../../modals/ModalEditCerfa";
import ModalCerfaGroupe from "../../modals/ModalCerfaGroupe";
import ModalChangeContact from "../../views/app-views/paiements/ModalChangeContact";
import ModalChangeOrigin from "../../views/app-views/paiements/ModalChangeOrigin";
import ModalDeletePaiement from "../../views/app-views/paiements/ModalDeletePaiement";
import ModalMessages from "../../views/app-views/messages/ModalEdit";
import {useActionSheet, withActionSheet} from "../providers/ActionSheetProvider";
import AppService from "../../services/AppService";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import MobPressable from "../components/MobPressable";
import {useNavigate} from "react-router-shim";
import ModalPromesse from "../../modals/ModalPromesse";

class SheetPromesseDetail extends SheetComponent
{
    constructor(props) {
        super(props);
    }

    onClose(){

    }

    getData(){
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()
        const item= payload?.params?.item
        const parentRefresh= payload?.params?.parentRefresh

        if(item)
        {
            ApiService.post("/promesses",{searchId:item.id,filters:{},sorter:{}}).then(res=>{
                if(Array.isArray(res.data) && res.data.length>0){
                    let _item=res.data[0]
                    sheetContext.setPayloadParams({item:_item})
                }
            })
        }

        if(typeof parentRefresh === "function"){
            parentRefresh()
        }
    }

    componentDidMount(){
        this.setState({sheetProps:{height:0.6}})
        this.getAssocs()
        this.getTypesComptes()
    }

    async getAssocs() {
        var res = await ApiService.get("/auth/assoc")
        if (res.success) {
            this.setState({assocs: res.data})
        }
    }

    async getTypesComptes() {
        var res2 = await ApiService.get("/paiements/cerfa/types/?groupe=1")
        console.log(res2)
        this.setState({typesComptes: res2.items})
    }

    async onDelete(id) {

        await ApiService.get("/promesses/delete/" + id)

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })

        //await this.getData()
    }

    renderContent()
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()

        const item= payload?.params?.item
        if(!item){
            return null
        }
        const row=item

        var assoc = null
        if (this.state.assocs.length > 0) {
            assoc = this.state.assocs.find(i => i.value === item.assoc)
        }

        var typesCompte = null
        if (Array.isArray(this.state.typesComptes) && this.state.typesComptes.length > 0) {
            typesCompte = this.state.typesComptes.find(i => i.value === item.typeId)
        }

        let showExtraCard=false
        const extras=[]
        if(item?.info?.extra)
        {
            showExtraCard=true
            for(let k of Object.keys(item?.info.extra))
            {
                if(k==="ddn"){
                    extras.push({key:t`Date de Naissance`,value:moment(new Date(item?.info.extra[k])).format("DD/MM/YYYY")})
                    continue
                }
                extras.push({key:removeFieldType(k),value:item?.info.extra[k]})
            }
        }
        if(item.commentaire?.length>0 || (item?.extra && Object.keys(item?.extra).length>0) ){
            showExtraCard=true
        }

        let raisonRoute=null
        switch(item.type){
            case "CAISSE":
                raisonRoute=MOBILE_PREFIX_PATH+"/cagnottes/fiche?id="+item.typeId
                break
        }

        var MENU = [
            { icon:"share",text:(<Trans>Partager la Promesse</Trans>),onClick:()=>{
                    requestLinkPayload("PAIEMENT",{
                        type: "DETTE",
                        typeId: row.id,
                        assoc:row.assoc,
                        devise:row.devise
                    }).then((url)=>{
                        if(url){
                            if(!AppService.isAvailable && navigator?.share){
                                navigator.share({
                                    url:url,
                                })
                            }else {
                                AppService.share({
                                    message:url
                                })
                            }
                        }
                    })
                }},
            { icon:"edit",warning:true,text:(<Trans>Modifier la Promesse</Trans>),onClick:()=>this.modalPromesse.edit(row.id, row.contact.id)},
        ]

        if(item.active){
            MENU.push({
                icon:"trash-2",
                danger:true,
                text:(
                    <Trans>Supprimer la promesse</Trans>
                ),
                onClick:()=>{
                    this.props.actionSheetManager.confirm((<Trans>Êtes-vous sûrs de vouloir supprimer cette promesse de don ?</Trans>),()=>{
                        this.onDelete(row.id)
                    })
                }
            },)
        }

        let DropdownComponent=null
        if(!isMobileApp){
            DropdownComponent= this.props.actionSheetManager.toDropdown(MENU)
            //console.log("DropdownComponent", DropdownComponent)
        }

        let formatedStatus=""
        let amountSymbol="+"
        let amountColor=MOBCOLORS.green.color
        let statusColor=MOBCOLORS.green.color
        let primaryAmount=item.payed

        if(item.payed===0){
            amountSymbol=""
            amountColor=MOBCOLORS.gray.color
        }

        if(item.active && item.reste>0){
            formatedStatus=t`En attente`
            statusColor=MOBCOLORS.orange.color
        }
        if(item.active && item.reste<=0){
            formatedStatus=t`Réglé`
            statusColor=MOBCOLORS.green.color
        }
        if(!item.active){
            amountSymbol="-"
            amountColor=MOBCOLORS.red.color
            primaryAmount=item.reste

            formatedStatus=t`Annulé`
            statusColor=MOBCOLORS.red.color
        }

        return(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>

                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",textAlign:"center",gap:0}}>
                    <span style={{fontSize:15}}>{moment(item.datetime).format("DD/MM/YYYY à HH:mm")}</span>
                    <span style={{fontSize:18,fontWeight:"bold",color:MOBCOLORS.blue.color}}>{item.name}</span>
                </div>


                <div style={{display:"flex",flexDirection:"column",gap:20}}>
                    <MobCard style={{display:"flex",flexDirection:"column",gap:10,position:"relative"}}>

                        <div style={{position:"absolute",right:0,paddingRight:10,paddingTop:5}}>
                            {isMobileApp ?(
                                <MobEditButtonIcon icon={"ellipsis-vertical"} onClick={()=>{
                                    if(MENU.length>0) {
                                        this.props.actionSheetManager.open(MENU)
                                    }
                                }}/>
                            ):(
                                <DropdownComponent>
                                    <a onclick={(e)=>e.preventDefault()}>
                                        <MobEditButtonIcon icon={"ellipsis-vertical"}/>
                                    </a>
                                </DropdownComponent>
                            )}
                        </div>


                        <span style={{
                            alignSelf: "center",
                            color: amountColor,
                            fontWeight: "bold",
                            fontSize: 26
                        }}>{amountSymbol} {currencyFormat(primaryAmount, item.devise)} <span style={{color:MOBCOLORS.gray.color,fontSize:15}}>/ {currencyFormat(item.montant, item.devise)}</span></span>

                        <div style={{
                            display: "flex",
                            width: "100%",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0 5%"
                        }}>
                            <span style={{alignSelf:"center",color:MOBCOLORS.orange.color,fontSize:15,fontStyle:"italic",fontWeight:"300"}}><Trans>Restant</Trans> : <span style={{fontWeight:"bold",fontStyle:"normal"}}>{currencyFormat(item.reste,item.devise)}</span></span>

                            <span style={{alignSelf:"center",color:MOBCOLORS.green.color,fontSize:15,fontStyle:"italic",fontWeight:"300"}}><Trans>Réglé</Trans> : <span style={{fontWeight:"bold",fontStyle:"normal"}}>{currencyFormat(item.payed,item.devise)}</span></span>
                        </div>

                        <Divider/>

                        {assoc &&(
                            <Item name={(<Trans>Association</Trans>)} value={assoc.label}/>
                        )}

                        {item.contact &&(
                            <Item name={(<Trans>Contact</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    //this.props.sheetContext.cancel()
                                    //this.props.navigate(MOBILE_PREFIX_PATH+"/contacts/fiche?id="+item.contact.id)
                                    this.props.sheetContext.openContact(item.contact)

                                }}>
                                    <DynamicIcon name={"contact"} color={MOBCOLORS.blue.color} size={18}/>
                                    {item.contact?.nom} {item.contact?.prenom}
                                </span>
                            </Item>
                        )}

                        {typesCompte &&(
                            <Item name={(<Trans>Livret</Trans>)} value={typesCompte.label}/>
                        )}

                        {item.abo &&(
                            <Item name={(<Trans>Abonnement</Trans>)}>
                                <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                                    ApiService.post("/abonnements",{searchId:item.abo,filters:{},sorter:{}}).then(res=>{
                                        if(Array.isArray(res.data) && res.data.length>0){
                                            let _item=res.data[0]
                                            this.props.sheetContext.open("SheetAbonementDetail",_item.payload.name,{item:_item})
                                        }
                                    })
                                }}>
                                    <Trans>Voir l'abonnement</Trans>
                                </span>
                            </Item>
                        )}

                        <Item name={(<Trans>Statut</Trans>)} value={formatedStatus} color={statusColor}/>

                        <Item name={(<Trans>Montant total</Trans>)} value={currencyFormat(item.montant,item.devise)} color={MOBCOLORS.gray.color}/>
                        <Item name={(<Trans>Montant réglé</Trans>)} value={currencyFormat(item.payed,item.devise)} color={item.payed?MOBCOLORS.green.color:MOBCOLORS.gray.color}/>
                        <Item name={(<Trans>Montant restant</Trans>)} value={currencyFormat(item.reste,item.devise)} color={item.reste?MOBCOLORS.red.color:MOBCOLORS.green.color}/>

                        {item.lastPaiementDate &&(
                            <Item name={(<Trans>Dernier paiement</Trans>)} value={moment(new Date(item.lastPaiementDate)).format("DD/MM/YYYY HH:mm")}/>
                        )}
                    </MobCard>



                </div>


                <ModalLink getRef={(ref) => this.modalLink = ref} onFinish={() => {
                }}/>
                <ModalUser getRef={(ref) => this.modalUser = ref} onFinish={() => {
                }}/>
                <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                }}/>
                <ModalCerfa getRef={(ref) => this.modalCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalEditCerfa getRef={(ref) => this.modalEditCerfa = ref} onFinish={() => this.getData(true)}/>
                <ModalCerfaGroupe getRef={(ref) => this.modalCerfaGroupe = ref} onFinish={() => this.getData(true)}/>
                <ModalChangeContact getRef={(ref) => this.modalChangeContact = ref} onFinish={() => this.getData()}/>
                <ModalChangeOrigin getRef={(ref) => this.modalChangeOrigin = ref} onFinish={() => this.getData()}/>
                <ModalDeletePaiement getRef={(ref) => this.modalDeletePaiement = ref} onFinish={() => this.getData()}/>
                <ModalMessages getRef={(ref) => this.modalMessages = ref} onFinish={() => {
                }}/>

                <ModalPromesse getRef={(ref) => this.modalPromesse = ref} onFinish={() =>{
                    this.getData()
                }}/>
            </div>
        )
    }
}

function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigate(withActionSheet(SheetPromesseDetail))

function Divider(){
    return(
        <div style={{width:"100%",paddingLeft:"5%",opacity:0.05}}>
            <div style={{width:"100%",borderTop:"1px solid #4A5568"}}/>
        </div>
    )
}

function DividerVertical(){
    return(
        <div style={{height:20,opacity:0.05}}>
            <div style={{height:"100%",borderLeft:"1px solid #4A5568"}}/>
        </div>
    )
}

function Section({title,children})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>

            <div style={{display:"flex",flexDirection:"row",textAlign:"center",justifyContent:"center",alignItems:"center"}}>
                <span style={{color:"#333",fontSize:18,fontWeight:"300"}}>{title}</span>
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:10}}>
                {children}
            </div>
        </div>
    )
}

function Item({name,value,color,children,bold})
{


    return(
        <div style={{display:"flex",flexDirection:"column",gap:10,padding:"0 2.5%"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",fontSize:15}}>

                <span style={{width:"40%",fontStyle:"italic",fontWeight:"300",color:"#333",fontSize:13}}>{name}</span>

                <div style={{display:"flex",textAlign:"right",alignItems:"flex-end",maxWidth:"60vw",overflow:"hidden",textOverflow:'ellipsis',color:color || MOBCOLORS.blue.color}}>
                    {value ?(
                        <span>{value?.toString().replaceAll("undefined","").trim() || t`[Inconnu]`}</span>
                    ):(
                        <div>{children}</div>
                    )}
                </div>
            </div>

            <Divider/>
        </div>
    )
}

function SheetButton({name,icon,onClick})
{
    return(

        <MobPressable style={{display:"flex",alignItems:"center",gap:5,backgroundColor:MOBCOLORS.blue.backgroundColor,padding:"5px 15px",borderRadius:16}} onClick={onClick}>
            <span style={{fontWeight:"400",color:MOBCOLORS.blue.color}}>{name}</span>
            <DynamicIcon name={icon} color={MOBCOLORS.blue.color} size={18} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
        </MobPressable>
    )
}
